'use es6';

import TypedRecord from './TypedRecord';
export default TypedRecord({
  reason: undefined
}, 'ResolverError');